import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector, OnDestroy } from '@angular/core'
import { CountryBarComponent } from '../../components/country-bar/country-bar.component'
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs'
import { MbDocumentService } from '../mb-document-service/mb-document.service'
import { WindowRef } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class CountryBarService implements OnDestroy {

  private showCountryBar$ = new BehaviorSubject(false)
  private pageReady$ = new BehaviorSubject(false)
  private componentRef: ComponentRef<CountryBarComponent> | undefined
  private subscription = new Subscription()
  private observer: MutationObserver | undefined
  private selectorContainer = 'main > cx-page-layout:last-child'

  constructor (private cfr: ComponentFactoryResolver,
               private injector: Injector,
               private documentService: MbDocumentService,
               private winRef: WindowRef) {
  }

  init (): void {
    if (this.winRef.isBrowser()) {
      this.addObserver()
    }
    this.subscription.add(
      combineLatest([this.showCountryBar$, this.pageReady$]).subscribe(([show, pageReady]) => {
        if (show && pageReady) {
          this.addCountryBar()
        }
      })
    )
  }

  showCountryBar (): void {
    this.showCountryBar$.next(true)
  }

  hideCountryBar (): void {
    this.showCountryBar$.next(false)
  }

  addCountryBar (): void {
    const mainContainer = this.documentService.querySelector(this.selectorContainer)
    if (mainContainer && !mainContainer?.querySelector('mb-country-bar')) {
      this.toggleBodyClass()
      const componentRef = this.cfr.resolveComponentFactory(CountryBarComponent)
        .create(this.injector)
      this.subscription.add(componentRef.instance.closeEvent.subscribe(() => {
        this.removeCountryBar()
      }))
      this.getAppRef().attachView(componentRef.hostView)
      const dom = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement
      mainContainer.append(dom)
    }
  }

  removeCountryBar (): void {
    this.showCountryBar$.next(false)
    this.winRef.document.body.classList.remove('country-notification-bottom')
    this.detachCountryBar()
  }

  ngOnDestroy (): void {
    this.detachCountryBar()
    this.subscription.unsubscribe()
  }

  private addObserver () {
    this.observer = new MutationObserver((mutations, obs) => {
      const body = this.documentService.querySelector(this.selectorContainer)
      if (body) {
        this.pageReady$.next(true)
        obs.disconnect()
      }
    })
    this.observer?.observe(document, {
        childList: true,
        subtree: true
      }
    )
  }

  private toggleBodyClass (): void {
    this.winRef.document.body.classList.toggle('country-notification-bottom')
  }

  private detachCountryBar (): void {
    if (this.componentRef) {
      this.getAppRef().detachView(this.componentRef?.hostView)
    }
  }

  private getAppRef (): ApplicationRef {
    return this.injector.get(ApplicationRef)
  }
}
